function n(e) {
  return e / 1024;
}
function t(e) {
  return e / 1024 ** 2;
}
function u(e) {
  return !e || e < 0 ? "" : e < 10 ? `${e} bytes` : e < 900 ? `${n(e).toFixed(2)} KB` : e < 1024 ** 2 ? `${n(e).toFixed(0)} KB` : `${t(e).toFixed(0)} MB`;
}
function i(e, r) {
  return r ? "error" : e === 0 ? "pending" : e >= 100 ? "success" : "uploading";
}
function o(e) {
  switch (e) {
    case "success":
      return "Upload complete.";
    case "pending":
      return "Pending...";
    default:
      return "Uploading...";
  }
}
export {
  u as formatBytes,
  i as getFileUploadItemStatus,
  o as getFileUploadItemStatusText
};
